import axios from "@/components/api/axios";

async function getThumbnailList(categoryName, page, query) {
  // URLSearchParamsは追加した値に?や&をqueryに対応するように修正してくれる
  const params = new URLSearchParams();

  if (categoryName) {
    params.append("category", categoryName);
  }
  if (page) {
    params.append("page", page);
  }
  if (query) {
    params.append("query", query);
  }
  const res = await axios.axiosGet(
    `/api/fanClub/leaders/getThumbnailList?${params.toString()}`
  );
  console.log(params.toString());
  return res;
}

async function getCategoryHeader(categoryName) {
  const query = categoryName ? `category=${categoryName}` : "";
  const res = await axios.axiosGet(
    `/api/fanClub/leaders/getCategoryHeader?${query}`
  );
  return res;
}

export default {
  getThumbnailList,
  getCategoryHeader
};



// WEBPACK FOOTER //
// ./src/components/api/fanClub/leaders/leadersList.js